const mutations = {
  UPDATE_FORM_COMPLETED(state, formCompleted) {
    state.formCompleted = formCompleted;
  },
  UPDATE_ID(state, id) {
    state.id = id
  },
  UPDATE_NAME(state, name) {
    state.name = name
  },
  UPDATE_BIRTH_DT(state, birthDt) {
    state.birthDt = birthDt
  },
  UPDATE_SEX_ID(state, sexId) {
    state.sexId = sexId
  },
  UPDATE_IS_DISABLE(state, isDisable) {
    state.isDisable = isDisable
  },
  UPDATE_ACADEMIC_LEVEL_ID(state, academicLevelId) {
    state.academicLevelId = academicLevelId
  },
  UPDATE_RELATIONSHIP_ID(state, relationshipId) {
    state.relationshipId = relationshipId
  },
  UPDATE_INSTITUTE_NAME(state, instituteName) {
    state.instituteName = instituteName
  },
  UPDATE_SCHOLARSHIP(state, scholarship) {
    state.scholarship = scholarship
  },
  UPDATE_IDENTITY_NUMBER(state, identityNo) {
    state.identityNo = identityNo
  },
}

const actions = {
  updateFormCompleted({
    commit
  }, formCompleted) {
    commit('UPDATE_FORM_COMPLETED', formCompleted)
  },
  updateId({
    commit
  }, id) {
    commit('UPDATE_ID', id);
  },
  updateName({
    commit
  }, name) {
    commit('UPDATE_NAME', name);
  },
  updateBirthDt({
    commit
  }, birthDt) {
    commit('UPDATE_BIRTH_DT', birthDt);
  },
  updateSexId({
    commit
  }, sexId) {
    commit('UPDATE_SEX_ID', sexId);
  },
  updateIsDisable({
    commit
  }, isDisable) {
    commit('UPDATE_IS_DISABLE', isDisable);
  },
  updateAcademicLevelId({
    commit
  }, academicLevelId) {
    commit('UPDATE_ACADEMIC_LEVEL_ID', academicLevelId);
  },
  updateRelationshipId({
    commit
  }, relationshipId) {
    commit('UPDATE_RELATIONSHIP_ID', relationshipId);
  },
  updateInstituteName({
    commit
  }, instituteName) {
    commit('UPDATE_INSTITUTE_NAME', instituteName);
  },
  updateScholarship({
    commit
  }, scholarship) {
    commit('UPDATE_SCHOLARSHIP', scholarship);
  },
  updateIdentityNo({
    commit
  }, identityNo) {
    commit('UPDATE_IDENTITY_NUMBER', identityNo);
  },
}

const getters = {
  FormCompleted: state => {
    return state.formCompleted
  },
  Id: state => {
    return state.id
  },
  Name: state => {
    return state.name
  },
  BirthDt: state => {
    return state.birthDt
  },
  SexId: state => {
    return state.sexId
  },
  IsDisable: state => {
    return state.isDisable
  },
  AcademicLevelId: state => {
    return state.academicLevelId
  },
  RelationshipId: state => {
    return state.relationshipId
  },
  InstituteName: state => {
    return state.instituteName
  },
  Scholarship: state => {
    return state.scholarship
  },
  IdentityNo: state => {
    return state.identityNo
  },
}

export default {
  namespaced: true,
  state() {
    return {
      formCompleted: true,
      id: 0,
      name: "",
      birthDt: 0,
      sexId: 0,
      isDisable: 0,
      academicLevelId: 0,
      relationshipId: 0,
      instituteName: "",
      scholarship: "",
      identityNo: "",
    }
  },
  getters,
  actions,
  mutations
}
